import { axios } from 'lib/axios';

export const forgotPassword = (data) => {
  return axios.post('/auth/forgot-password', data);
};
